import type { BookmarkToggleEvent } from 'shared/assets/types/Bookmark'
import GlobalStore from 'shared/globalStore/assets/scripts/globalStore'
import Toast from 'shared/toast/toast'

export default class Bookmark {
	private bookmark: HTMLElement | null
	private labelNotBookmarked: HTMLElement | null | undefined
	private labelBookmarked: HTMLElement | null | undefined
	private isBookmarked: boolean
	private store: GlobalStore
	private bookmarkType: string | null

	constructor() {
		this.bookmark = document.querySelector('.bookmark')
		this.labelNotBookmarked = this.bookmark?.querySelector('.bookmark-label.notBookmarked')
		this.labelBookmarked = this.bookmark?.querySelector('.bookmark-label.bookmarked')
		this.isBookmarked = false
		this.store = new GlobalStore()
		this.onPending = this.onPending.bind(this)
		this.onToggle = this.onToggle.bind(this)
		this.updateButtonAttributes = this.updateButtonAttributes.bind(this)
		this.onBookmarkInit = this.onBookmarkInit.bind(this)
		this.bookmarkType = this.bookmark?.getAttribute('data-id')?.split(':')[0] ?? null
	}

	init() {
		if (!this.bookmark) return
		this.addEvent()
	}

	addEvent() {
		this.bookmark?.addEventListener('click', this.onPending)
		document.addEventListener('BMK::TOGGLED', this.onToggle)
		document.addEventListener('BMK::STATUS-INIT-DONE', this.onBookmarkInit)
	}

	/**
	 * Set button attributes after bookmark initialization
	 */
	onBookmarkInit() {
		this.isBookmarked = this.bookmark?.getAttribute('data-bookmark-status') === 'true'
		this.updateButtonAttributes()
	}

	/**
	 * Activate a loading state during the Bookmark call
	 */
	onPending() {
		this.bookmark?.classList.add('isPending')
	}

	/**
	 * Callback for the custom event BMK::TOGGLED
	 * @param {CustomEventInit<BookmarkToggleEvent>} event
	 */
	onToggle(event: CustomEventInit<BookmarkToggleEvent>) {
		if (event.detail?.type === 'readitlater') {
			this.isBookmarked = !!event.detail?.status
			this.updateButtonAttributes()
			this.showToast()
		}
	}

	updateButtonAttributes() {
		this.bookmark?.classList.remove('isPending')
		this.bookmark?.setAttribute('aria-checked', String(this.isBookmarked))

		this.labelBookmarked?.setAttribute('aria-hidden', String(!this.isBookmarked))
		this.labelNotBookmarked?.setAttribute('aria-hidden', String(this.isBookmarked))
	}

	showToast() {
		const toast = new Toast({
			content: this.toastLabel
		})

		toast.init()
	}

	get toastLabel(): string {
		return this.isBookmarked
			? `${this.bookmarkType === 'recipe' ? 'Recette' : 'Article'} à retrouver dans votre compte ${this.store.brand?.labels.brand_name ?? ''}`
			: `${this.bookmarkType === 'recipe' ? 'Recette retirée' : 'Article retiré'} de vos favoris`
	}
}
